import React from 'react';
import {SelectPlatformDialog} from "../../../dialog/SelectPlatformDialog";
import {OS} from "../../../../../utils/CheckPlatform";

interface States {
}

interface Props {
}

class HowToInstallAppButton extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    selectedOs = (os: OS) => {

    }

    layout = () => {
        return (
            <div>
                      <span
                          className="howToInstallAppButton">
                          How to install
                      </span>
            </div>
        )
    }

    render() {
        return (
            <SelectPlatformDialog
                buttonUI={this.layout()}
                callback={this.selectedOs}/>
        )
    }
}

export default HowToInstallAppButton;
